import { CloseOutlined } from '@ant-design/icons';
import { Table, Button, Form, Input } from 'antd';
import { Content } from 'antd/es/layout/layout';
import Modal from 'antd/lib/modal/Modal';
import PermissionApi from 'apis/PermissionApi';
import { NextIcon } from 'assets/svg';
import { MainLayout } from 'components';
import useQueryParam from 'hooks/useQueryPrams';
import { useEffect, useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';
import pageTitleStore from 'store/pageTitleStore';
import { HocChangePagination } from 'utils/HocChangePagination';
import updateQueryStringParameter from 'utils/updateQueryStringParameter';

const FunctionPage = () => {
  const history = useHistory();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);
  const functionParams = {
    page: parseInt(useQueryParam().get('page') + '') || 1,
    page_size: 12,
  };

  const params = JSON.parse(JSON.stringify(functionParams));

  const {
    data: result,
    isLoading,
    refetch,
  } = useQuery(['getFunctions', params], () =>
    PermissionApi.getFunctions(params)
  );

  const columns = useMemo(() => {
    return [
      {
        title: 'Tên chức năng',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'Mô tả',
        dataIndex: 'description',
        key: 'description',
      },
      {
        title: 'Tiêu đề',
        dataIndex: 'title',
        key: 'title',
      },
    ];
  }, []);

  useEffect(() => {
    setTitle('Quyền');
    setBreadcrumb([{ title: 'Quyền' }]);
  }, []);

  return (
    <MainLayout isLoading={isLoading}>
      <Content className="main-content mt-4">
        <Table
          className="customTable"
          dataSource={result?.data}
          columns={columns}
          pagination={{
            className: 'flex items-center',
            current: functionParams.page,
            total: result?.total,
            showSizeChanger: true,
            pageSize: functionParams.page_size,
            defaultCurrent: functionParams.page,
            defaultPageSize: functionParams.page_size,
            pageSizeOptions: ['10', '20', '50'],
            onChange: HocChangePagination(history),
          }}
        />
      </Content>
    </MainLayout>
  );
};

export default FunctionPage;
